const labels = {
    product: 'Product',
    firstname: 'First Name',
    lastname: 'Last Name',
    email: 'Corporate Email',
    title: 'Job Title',
    company: 'Company',
    country: 'Country',
    phone: 'Phone Number',

    checkbox: `I agree with the <a href="https://www.starwindsoftware.com/privacy-policy" target="_blank">Privacy Policy</a> 
and allow the use of the provided information for communication purposes. 
I understand that I can withdraw my consent at any time by submitting the request to
 <a href="mailto:dataprotection@starwind.com">dataprotection@starwind.com</a>.`,

    checkbox_validation: 'Please confirm that you have read and accepted the Privacy Policy before proceeding',

    no_checkobox: `By submitting, you are agreeing to have your personal information managed in accordance with
 the terms of StarWind Software Inc <a href="https://www.starwindsoftware.com/privacy-policy" target="_blank">Privacy Policy</a>.`,


    contentDefault: `
        <div id="download-thank-you" class="thank-you-text download-thank-you">
            <div class="flex-grid centered">
                <div class="message-wrap">
                    <div class="title">Thank you!</div>
                    <div class="text">
                      The license key for {product_name_2024}<br> has been already sent to email:<br> <b>{this.email}</b>
                      <br><br>
                      If you do not find the email in your inbox, please check your spam/junk folder.
                    </div>
                </div>
            </div>
        </div>    
    `.trim(),


    contentNoLic: `
        <div id="download-thank-you" class="thank-you-text download-thank-you">
            <div class="flex-grid centered">
                <div class="message-wrap">
                    <div class="title">Thank you!</div>
                    <div class="text">
                      The download link for {product_name_2024}<br> has been already sent to email: <br> <b>{this.email}</b>
                      <br><br>
                      If you do not find the email in your inbox, please check your spam/junk folder.
                    </div>
                </div>
            </div>
        </div>
    `.trim(),


    contentDefault2: `
        <div id="download-thank-you" class="thank-you-text download-thank-you">
            <div class="flex-grid centered">
                <div class="message-wrap">
                    <div class="title">Thank you!</div>
                    <div class="text">
                        The license key and the download link has been sent to email:<br> <b>{this.email}</b>
                    </div>
                </div>
            </div>
        </div>    
    `.trim(),


}

export {labels}